import React from 'react'
import { FormattedMessage } from 'react-intl'

export default class IsLessThen255Symbols {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_title" />
  }

  validate() {
    const { value } = this

    if (
      (typeof value === 'string' || typeof value === 'number') &&
      value.length > 255
    ) {
      return this.errorMessage
    }

    return null
  }
}
